<template>
  <svg
    width="8"
    height="9"
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="4.5"
      width="5"
      height="5"
      transform="rotate(-45 0 4.5)"
      fill="currentColor"
    />
  </svg>
</template>
